module.exports = __webpack_public_path__ + "img/SKMJ_set.cc01bcf3.png";